export function parseId(str: string | undefined | null) {
  if (str === undefined || str === null) {
    return undefined;
  }
  const num = parseInt(str, 10);
  return Number.isNaN(num) ? undefined : num;
}
